import "../../style.css";
import { useState, useEffect, useCallback, useMemo } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { TbRefresh } from "react-icons/tb";

import { AgGridReact } from "ag-grid-react";
import { ToastContainer, toast } from "react-toastify";
import CustomPagination from "../../../../components/CustomPagination";
import TableSkeleton from "../../../../components/table/TableSkeleton.js";
import { MdClear } from 'react-icons/md';
import { getPaymentHistoryPath } from "../../../../services/config";

import {
  savePaymentHistory,
  initPaymentState,
} from "../../../../redux/slices/paymentHistory";

import {
  getCurrentDate,
  getFormattedUsers,
  downloadCSV,
  getFormattedPaymentHistory,
  getEmployeeFormattedDataOne,
  getInitials,
  getInitialColor,
  getCapitalizeWord,
} from "../../../../services/commonServices";

import {
  fetchBranchData,
  initBranchState,
} from "../../../../redux/slices/branchSlice";
import {
  fetchDepartmentData,
  initDepartState,
} from "../../../../redux/slices/departmentSlice";
import {
  fetchData,
  initShiftState,
} from "../../../../redux/slices/shiftsSlice";

import { useDispatch, useSelector } from "react-redux";
import { Height } from "@mui/icons-material";
import Widgets from "../../../../components/Widgets";

const PaymentHistory = () => {
  const dispatch = useDispatch();

  const [user] = useState(
    localStorage.getItem("user_data")
      ? JSON.parse(localStorage.getItem("user_data"))
      : null
  );

  const branchState = useSelector((state) => state.branch);
  const departState = useSelector((state) => state.department);
  const shiftState = useSelector((state) => state.shift);
  const paymentStore = useSelector((state) => state.paymentHistory);

  const date = new Date();
  const year = date.getFullYear();
  const month = date.toLocaleString("default", { month: "long" });

  const today = new Date().toISOString().split("T")[0];
  const today_ = new Date();

  const [maxMonth, setMaxMonth] = useState("");

  const [paymentHistory, setPaymentHistory] = useState([]);
  const [paymentHistoryOne, setPaymentHistoryOne] = useState([]);
  const [branch, setBranch] = useState([]);
  const [depart, setDepart] = useState([]);
  const [shift, setShift] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [startLeavingDate, setStartLeavingDate] = useState(null);
  const [endLeavingDate, setEndLeavingDate] = useState(null);

  const [state, setState] = useState({
    userId: user.user_id,
    staffId: "",
    selectedDate: "",
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const handleInputChange = ({ target: { name, value } }) => {
    setState((pre) => ({
      ...pre,
      [name]: value,
    }));

    if ((name = "selectedDate")) {
      getPaymentHistoryList(`${value}-01`);
    }
  };

  const getData = useCallback(() => {
    dispatch(fetchBranchData(user.user_id));
    dispatch(fetchDepartmentData(user.user_id));
    dispatch(fetchData(user.user_id));
  }, []);

  const getPaymentHistoryList = useCallback(
    (date) => {
      const data = {
        path: getPaymentHistoryPath,
        data: {
          userId: user.user_id,
          selectedDate: date,
        },
      };
      dispatch(savePaymentHistory(data));
    },
    [state.selectedDate]
  );

  useEffect(() => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    setMaxMonth(`${year}-${month}`);
    setState((prev) => ({
      ...prev,
      selectedDate: `${year}-${month}`,
    }));
    getPaymentHistoryList(`${year}-${month}-01`);
  }, []);

  // useEffect(() => {
  //   getData();
  // }, []);

  useEffect(() => {
    if (branchState.brnGetSuccess) {
      setBranch(branchState.brnGetData);
      dispatch(initBranchState());
    }

    if (departState.depGetSuccess) {
      setDepart(departState.depGetData);
      dispatch(initDepartState());
    }

    if (shiftState.shiftGetSuccess) {
      setShift(shiftState.shiftGetData);
      dispatch(initShiftState());
    }
    if (paymentStore.paymentSuccess) {
      if (searchQuery != "") {
        searchEmployees(searchQuery, paymentStore.paymentData)
      }
      else {
        setPaymentHistory(paymentStore.paymentData);
        setPaymentHistoryOne(paymentStore.paymentData);
        dispatch(initPaymentState());
      }

    }
    if (paymentStore.paymentError) {
      setPaymentHistory([]);
      setPaymentHistoryOne([]);
      dispatch(initPaymentState());
    }
  }, [branchState, departState, shiftState, paymentStore, dispatch]);

  const handleClickFromD1 = (id) => {
    document.getElementById(id).click();
  };

  const paginationPageSize = 10;
  const paginationPageSizeSelector = [10, 20, 50, 100];

  const columns = [
    {
      headerName: "SNo",
      valueGetter: (params) => params.node.rowIndex + 1,
      width: 60,
      pinned: "left",
    },
    {
      headerName: "Employee ID",
      field: "employeeId",
      pinned: "left",
      width: 120,
    },
    {
      headerName: "Name",
      filter: true,
      pinned: "left",
      flex: 1,
      width: "350px",
      cellRenderer: (row) => {
        return (
          <span
            // className="navigate-link"
            className="table-link d-flex align-items-center justify-content-start gap-2"
          >
            <div
              style={{
                width: "30px",
                height: "30px",
                border: "1px solid lightgray",
                borderRadius: "50%",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: getInitialColor(row.data.staffName), // 🎯 Apply color
                color: "white", // Text contrast
                fontWeight: "bold",
                fontSize: "12px",
              }}
            >
              {getInitials(row.data.staffName)}
              {/* <img
                                src={Avatar}
                                style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                              /> */}
            </div>
            {getCapitalizeWord(row.data.staffName)}
          </span>
        );
      },
    },
    {
      headerName: "Payment Date",
      cellRenderer: (rowData) => {
        return <span>{rowData.data.payrollMonthYear}</span>;
      },
      filter: true,
      width: "200px",
    },
    {
      headerName: "Payroll Type",
      field: "payrollType",
      filter: true,
      width: "200px",
    },
    {
      headerName: "Amount Paid",
      cellRenderer: (rowData) => {
        return <span>{rowData.data.paid ? rowData.data.paid : "-"}</span>;
      },
      filter: true,
      width: "200px",
    },
    {
      headerName: "Status",
      cellRenderer: (rowData) => {
        return (
          <span>
            {rowData.data.status
              ? rowData.data.status == "1"
                ? "Active"
                : "InActive"
              : "-"}
          </span>
        );
      },
      filter: true,
      width: "200px",
    },

    {
      headerName: "Transaction ID",
      cellRenderer: (rowData) => {
        return (
          <span>
            {rowData.data.transactionId ? rowData.data.transactionId : "-"}
          </span>
        );
      },
      filter: true,
      width: "200px",
    },
    {
      headerName: "UTR Number",
      cellRenderer: (rowData) => {
        return (
          <span>{rowData.data.utrNumber ? rowData.data.utrNumber : "-"}</span>
        );
      },
      filter: true,
      width: "200px",
    },
    {
      headerName: "Paid By",
      cellRenderer: (rowData) => {
        return <span>{rowData.data.paidBy ? rowData.data.paidBy : "-"}</span>;
      },
      filter: true,
      width: "200px",
    },
  ];


  const searchEmployees = (value, dataList) => {
    setSearchQuery(value);
    const filteredEmployees = dataList.filter(
      (v) =>
        v.staffName.toLowerCase().includes(value.toLowerCase()) ||
        (v.employeeId &&
          v.employeeId.toLowerCase().includes(value.toLowerCase()))
    );
    setPaymentHistory(filteredEmployees);
    setPaymentHistoryOne(dataList)
  };

  const refresh = () => {
    setSearchQuery("");
    // setPaymentHistory(paymentHistoryOne);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    setMaxMonth(`${year}-${month}`);
    setState((prev) => ({
      ...prev,
      selectedDate: `${year}-${month}`,
    }));
    getPaymentHistoryList(`${year}-${month}-01`);
  };

  const DownloadCSVFile = () => {
    if (paymentHistory.length) {
      downloadCSV(
        getEmployeeFormattedDataOne(paymentHistory, 6),
        `${getCurrentDate()}_attendance.csv`
      );
    } else {
      toast.error("No data for download the report.");
    }
  };

  const date_1 = new Date();
  const year_1 = date_1.getFullYear();
  const month_1 = String(date_1.getMonth() + 1).padStart(2, "0");
  const clearFilter = () => {
    setSearchQuery("")
    setState((pre) => ({
      ...pre,
      selectedDate: `${year_1}-${month_1}`,
      branch: "",
      shiftId: "",
      departmentId: "",
    }))
    getPaymentHistoryList(`${year_1}-${month_1}-01`);
    // submitDataForAdvance(`${year}-${month}`, state.branchId, state.shiftId);
  }

  // HTML ELEMENT RENDERING ---------------------------------------------------
  return (
    <div
      style={{ position: "fixed", width: "calc(100% - 20px)", height: "100%" }}
    >
      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />

      <Row>
        <Col sm="12">
          <div className="top-header mt-2 mb-2">
            <Form.Group className="flex-dis">
              <Form.Control
                placeholder="Search"
                className="universal-input color-white"
                value={searchQuery}
                onChange={(e) => searchEmployees(e.target.value, paymentHistoryOne)}
                style={{
                  width: "200px",
                  backgroundColor: "transparent",
                }}
              />

              <Form.Group>
                <Form.Control
                  type="month"
                  name="selectedDate"
                  value={state.selectedDate}
                  max={maxMonth}
                  onChange={handleInputChange}
                  className="universal-input color-white"
                  style={{
                    width: "200px",
                    backgroundColor: "transparent",
                  }}
                />
              </Form.Group>

              <Form.Group>
                {
                  (
                    searchQuery ||
                    state.selectedDate != `${year_1}-${month_1}` ||
                    state.shiftId ||
                    state.departmentId ||
                    state.branch) && <button type="button" className="clear" onClick={clearFilter}>
                    <MdClear /> Clear
                  </button>
                }
              </Form.Group>

              {/* <Form.Group>
                <Form.Select
                  className="border-gray"
                  style={{
                    width: "200px",
                    color: "white",
                    backgroundColor: "transparent",
                  }}
                >
                  <option value="">All Branches</option>
                  {branch.map((row, idx) => {
                    return (
                      <option value={row.branchId} key={idx}>
                        {row.branch_name}
                      </option>
                    );
                  })}
                </Form.Select>
              </Form.Group>

              <Form.Group>
                <Form.Select
                  className="border-gray"
                  style={{
                    width: "200px",
                    color: "white",
                    backgroundColor: "transparent",
                  }}
                >
                  <option value="">Payment Mode</option>
                </Form.Select>
              </Form.Group> */}

              <button
                type="button"
                className="refresh universal-input-one"
                onClick={refresh}
              >
                <TbRefresh /> Refresh
              </button>
              <button
                type="button"
                className="download-report universal-input-one"
                onClick={DownloadCSVFile}
              >
                Download Report
              </button>
            </Form.Group>
          </div>

          <Widgets
            body={
              <>
                <div
                  className="ag-theme-quartz custom-grid"
                  style={{
                    height: "calc(100vh - 280px)",
                    width: "100%",
                    padding: "0px 20px",
                    overflow: "auto",
                  }}
                >
                  {paymentStore.paymentLoading ? (
                    <TableSkeleton />
                  ) : (
                    <AgGridReact
                      rowData={Array.isArray(paymentHistory) ? paymentHistory : []}
                      columnDefs={columns}
                      pagination={true}
                      paginationPageSize={paginationPageSize}
                      onGridReady={onGridReady}
                    />
                  )}
                </div>

                <div className="d-flex align-items-center justify-content-between custom-pagination px-4">
                  {gridApi && <CustomPagination gridApi={gridApi} />}
                  {/* <div className="d-flex align-items-center justify-content-start gap-3 color-white">
                    <span>Grand Totals</span>
                    <span> &#8377; 11,200</span>
                  </div> */}
                </div>
              </>
            }
          />
        </Col>
      </Row>
    </div>
  );
};

export default PaymentHistory;



/*

TDS UI fields 1. Search box 2. Month, Salary Type, Branch, Department, Join Date, Leave Date -  filters 3. Employee Name 4. Job title5. Tax Regime 6. Earnings7. Excemptions8. Deductions9. Standard Deduction10. Taxable Income11. Taxable Liability12. Total

*/